import PeriodModel               from '@models/shop/PeriodModel';
import ProductPricingStatusModel from '@models/shop/ProductPricingStatusModel';
import doc                       from '@widesk-core/decorators/doc';
import model                     from '@widesk-core/decorators/model';
import ShopServiceModel          from '@/models/ShopServiceModel';
import TimestampAble             from '@widesk-core/models/traits/TimestampAble';
import Blamable                  from '@/models/traits/Blamable';
import ProductVariantModel       from '@models/shop/ProductVariantModel';

@model.urnResource('product_pricing')
@doc.path('/product_pricings/{?id}')
export default class ProductPricingModel extends Blamable(TimestampAble(ShopServiceModel)) {
	private declare _tsFilters: {
		'createdAt[after]': string | Date | Dayjs;
		'createdAt[before]': string | Date | Dayjs;
		'createdAt[strictly_after]': string | Date | Dayjs;
		'createdAt[strictly_before]': string | Date | Dayjs;
		'period': id;
		'period.periodGroup': id;
		'productPricingStatus': id;
		'productPricingStatus.reference': Shop_ProductPricingStatusReference;
		'productVariant': id;
		'productVariant.product': id;
		'productVariant.product.entertainment': id;
		'productVariant.product.entertainment.entertainmentUrn': Urn;
		'stock[between]': string;
		'stock[gt]': string;
		'stock[gte]': string;
		'stock[lt]': string;
		'stock[lte]': string;
		'updatedAt[after]': string | Date | Dayjs;
		'updatedAt[before]': string | Date | Dayjs;
		'updatedAt[strictly_after]': string | Date | Dayjs;
		'updatedAt[strictly_before]': string | Date | Dayjs;
	};

	private declare _tsSorts: {
		'createdAt': string;
		'id': string;
		'period.startDate': string;
		'stock': string;
		'updatedAt': string;
	};

	@doc.model(PeriodModel) declare period: PeriodModel;
	@doc.model(ProductPricingStatusModel) declare productPricingStatus: ProductPricingStatusModel;
	@doc.model(ProductVariantModel) declare productVariant: ProductVariantModel;
	@doc.number declare stock: number;
}